export default __webpack_public_path__ + "static/media/pic2.127475b0.PNG";